import { sendFetch, GET_OPTIONS } from './base.service';

const BASE_PATH = '/cities';

export const findAllCities = async () => {
    return await sendFetch(`${BASE_PATH}/all`, GET_OPTIONS);
}

export const findAllCitiesByDepartment= async (department) => {
    return await sendFetch(`${BASE_PATH}/all/department/${department}`, GET_OPTIONS);
}